export type PlanInterval = 'monthly' | 'semiannual' | 'annual'

export const PLAN_META: Record<
  PlanInterval,
  { billingKey: string; highlight: boolean; badgeKey?: string }
> = {
  monthly: { billingKey: 'plans.monthly.billedAs', highlight: false },
  semiannual: {
    billingKey: 'plans.semiannual.billedAs',
    highlight: true,
    badgeKey: 'plans.semiannual.badge',
  },
  annual: { billingKey: 'plans.annual.billedAs', highlight: false },
}

export const PLAN_ORDER: PlanInterval[] = ['monthly', 'semiannual', 'annual']

export const FEATURES = [
  'patientManagement',
  'staffManagement',
  'documentStorage',
  'financialTracking',
  'aiChatAssistant',
  'bulgarianSupport',
] as const
